export interface IPushNotification {
  type: string;
  source: string;
  resourceType: string;
  country: string | null;
  division: number;
  dealer: number;
  advisor: number;
  scheduleDate: string | null;
  scheduleHour: number;
  vin: string;
  fordProtect?: boolean;
  language?: string;
}


